module.exports = "https://cdn.dove.it/_next/static/public/assets/default-preview-social.ebee3d7edbaaf93c3cabf0359d4f26cd.png";